module.exports = (__webpack_require__(1))(189);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/NewAssetstoreWidget.js from dll-reference girder_lib
// module id = 29
// module chunks = 0